<template>
  <b-row>
    <b-col cols="8">
      <BfInput
        label="Nombre"
        data-key="nombre"
        :value="data.nombre"
        :edit-mode="editing"
        @update="updateForm"
        :errors="errors"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'PropertyStatusForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },
  },
};
</script>
